import { type ExtensionFieldObjectType } from "~/graphql/supergraphTypes";

export const generateCsvTemplate = (extensionFields: ExtensionFieldObjectType[]): string => {
  const headers = ["arena_id", "entity_name"];

  for (const field of extensionFields) {
    if (field.name) {
      headers.push(field.name);
    }
  }

  return headers.join(",") + "\n";
};

export const generateUniqueFileName = (
  originalFileName: string,
  userFullName: string,
): string => {
  const epoch = Date.now();
  const userName = userFullName.replace(/\s+/g, "_") || "user";
  const extension = originalFileName.substring(originalFileName.lastIndexOf("."));
  const nameWithoutExt = originalFileName.substring(0, originalFileName.lastIndexOf("."));

  return `${userName}_${epoch}_${nameWithoutExt}${extension}`;
};

export const createAndDownloadFile = (
  content: string,
  filename: string,
  mimeType: string,
): void => {
  const blob = new Blob([content], { type: mimeType });
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);

  link.setAttribute("href", url);
  link.setAttribute("download", filename);
  link.click();

  URL.revokeObjectURL(url);
};
